/* Homepage anchor links scroll natively — smooth scrolling comes from the
   scroll-behavior rule in sypnosis.css, landing offset from the global
   .shopify-section scroll-margin-top there. The old jQuery scrollTop-animate
   handler that lived here fought that CSS rule (each animation tick became its
   own smooth scroll), causing laggy scrolling — removed 22.07.26. */

jQuery(document).ready(function($) {
    // Wait for the document to be ready
    $(".utility-bar .close").click(function() {
        // Toggle the visibility of the content
        $(".utility-bar").hide();
    });
});

// GS20
document.addEventListener('DOMContentLoaded', function () {
  function handleClick() {
    // Targeting (X button) element 
    var summaryElement = document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset[aria-label="Menu"][role="button"][aria-expanded="true"][aria-controls="menu-drawer"]');

    if (summaryElement instanceof HTMLElement) {
      summaryElement.click();
    } else {
      console.error('Element with the specified attributes not found or not a valid HTML element.');
    }
  }

  function addClickListeners() {
    var joinTheClubElement = document.getElementById('HeaderDrawer-join-the-club');
    var navLogoImage = document.getElementById('gs20-scrollFix');

    if (joinTheClubElement) {
      joinTheClubElement.addEventListener('click', handleClick);
    } else {
      console.error('Element with ID "HeaderDrawer-join-the-club" not found.');
    }

    if (navLogoImage) {
      navLogoImage.addEventListener('click', function(event) {
        event.preventDefault();
        handleClick();

        setTimeout(function() {
          window.location.href = navLogoImage.getAttribute('href');
        }, 300); // Adjust the delay as needed
      });
    } else {
      console.error('Element with ID "gs20-scrollFix" not found.');
    }
  }

  function waitForElementToLoad() {
    var intervalId = setInterval(function () {
      var joinTheClubElement = document.getElementById('HeaderDrawer-join-the-club');
      var navLogoImage = document.getElementById('gs20-scrollFix');

      if (joinTheClubElement && navLogoImage) {
        clearInterval(intervalId); // Stop checking once both elements are found
        addClickListeners();
      }
    }, 100);
  }

  waitForElementToLoad();
});

// GS20 (testing custom events)
document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("Details-menu-drawer-container").addEventListener("click", function() {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({
      event: "Hamburger menu clicked"
    });
  });
});

// GS19 
document.addEventListener('DOMContentLoaded', function() {
  var exitButton = document.getElementById('button-exit');
  if (exitButton) {
    exitButton.addEventListener('click', function handleClick() {
      // Check if the warning message div already exists
      if (!document.getElementById('age-warning')) {
        // Create the warning message div
        var warningDiv = document.createElement('div');
        warningDiv.id = 'age-warning';
        warningDiv.style.color = 'red';
        warningDiv.style.marginBottom = '20px';
        warningDiv.style.display = 'block';
        warningDiv.style.fontWeight = 'bold';
        warningDiv.textContent = "You can't enter without confirming you are over 18.";

        // Append the warning message div after the specific span
        var paragraph = document.querySelector('#age-check-prompt span p');
        paragraph.parentNode.appendChild(warningDiv);
      }

      // Remove the href attribute from the button
      document.getElementById('button-exit').removeAttribute('href');

      // Disable the button after it's clicked
      document.getElementById('button-exit').removeEventListener('click', handleClick);
    });
  }
});

// GS27
document.addEventListener('DOMContentLoaded', function() {
  function updateCountdown() {
    var now = new Date();
    
    // Calculate the first day of the next month
    var nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    
    // Calculate the difference in milliseconds
    var timeLeft = nextMonth - now;
    
    // Calculate the days, hours, and minutes left
    var daysLeft = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    var hoursLeft = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    
    // Update the countdown display
    document.getElementById('gs27-countdown').innerHTML =
      daysLeft + " days : " + hoursLeft + " hours : " + minutesLeft + " minutes";
    
    // Repeat the function every minute
    setTimeout(updateCountdown, 60000);  // 60000 milliseconds = 1 minute
  }
  
  updateCountdown();
});

// Fix for nav item "JOIN THE CLUB!" braking the scroll
document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('HeaderDrawer-purchase-today').addEventListener('click', function () {
    // Target the specific <summary> element with the given class names
    var summaryElement = document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset[aria-label="Menu"][role="button"][aria-expanded="true"][aria-controls="menu-drawer"]');

    if (summaryElement instanceof HTMLElement) {
      summaryElement.click();
    } else {
      console.error('Element with the specified attributes not found or not a valid HTML element.');
    }
  });
});

// GS PDP Redesign
document.addEventListener('DOMContentLoaded', function () {
  function simulateClickOnSecondLi() {
    const ulElement = document.querySelector('.thumbnail-list.slider.slider--mobile');

    if (ulElement) {
      const secondLi = ulElement.querySelector('li:nth-child(2)');
      if (secondLi) {
        const button = secondLi.querySelector('button');

        if (button) {
          button.click();
        } else {
          console.error('Button not found in the second li element.');
        }
      } else {
        console.error('Second li element not found.');
      }
    } else {
      console.error('Parent ul element not found.');
    }
  }

  simulateClickOnSecondLi();
});

// GS03 V2 - Dynamic cart button price updates
(function () {
  function initGS03() {
    const container = document.getElementById('gs03-v2');
    if (!container) return;

    // Find the button - it's now in the parent form, not inside gs03-v2
    const form = container.closest('form');
    const cartButton = form ? form.querySelector('[data-gs03-cart-button]') : null;
    const upsellCard = container.querySelector('.gs03-upsell-card');

    if (!cartButton || !upsellCard) return;

    // Get prices from theme settings, fallback to defaults
    const defaultStates = {
      regular: { compare: '$213+', current: '$99' },
      deluxe: { compare: '$243+', current: '$129' },
    };
    
    const states = window.themeSettings?.subscriptionPrices || defaultStates;

    function ensureStructure() {
      let textWrapper = cartButton.querySelector('.text');
      if (!textWrapper) {
        textWrapper = document.createElement('span');
        textWrapper.className = 'text';
        cartButton.appendChild(textWrapper);
      }
      if (
        !textWrapper.querySelector('.gs03-cart-price__compare') ||
        !textWrapper.querySelector('.gs03-cart-price__current')
      ) {
        // Use regular subscription prices as initial defaults
        const initialPrices = states.regular;
        textWrapper.innerHTML = `
          <span class="gs03-cart-label">ADD TO CART</span>
          <span class="gs03-cart-divider"> - </span>
          <span class="gs03-cart-price">
            <span class="gs03-cart-price__compare">${initialPrices.compare}</span>
            <span class="gs03-cart-price__current">${initialPrices.current}</span>
          </span>
        `;
      }
      return {
        compareNode: textWrapper.querySelector('.gs03-cart-price__compare'),
        currentNode: textWrapper.querySelector('.gs03-cart-price__current'),
      };
    }

    function isBiMonthlyBtn(btn) {
      if (!btn) return false;
      const name = (btn.getAttribute('data-plan-name') || '').toLowerCase();
      return /\b2\s*months?\b/.test(name);
    }

    function getCurrentBiMonthly() {
      const selected = form && form.querySelector('#gs03-frequency-picker .gs03-frequency-option.is-selected');
      return isBiMonthlyBtn(selected);
    }

    function applyState(isDeluxe, isBiMonthly) {
      const nodes = ensureStructure();
      // Read fresh from themeSettings (allows the merchant to override prices via the customizer)
      const currentStates = window.themeSettings?.subscriptionPrices || states;
      const state = isDeluxe ? currentStates.deluxe : currentStates.regular;
      const currentPrice = isBiMonthly
        ? (state.bimonthly || (isDeluxe ? '$139' : '$109'))
        : state.current;

      if (nodes.compareNode && nodes.currentNode) {
        nodes.compareNode.textContent = state.compare;
        nodes.currentNode.textContent = currentPrice;
      }

      // Also update the homepage price heading ("ONLY $99 PER BOX!").
      // Scoped to the section's .product_info so we don't accidentally touch
      // unrelated .heading.m-b-0 elements elsewhere on the page.
      const infoScope = form && form.closest('.product_info');
      if (infoScope) {
        infoScope.querySelectorAll('.heading.m-b-0').forEach(function (el) {
          el.textContent = el.textContent.replace(/\$\d{2,3}/, currentPrice);
        });
      }
    }

    function initState() {
      const isDeluxe = upsellCard.classList.contains('is-active');
      applyState(isDeluxe, getCurrentBiMonthly());
    }

    // Observe changes (Loop may rewrite button content)
    const observer = new MutationObserver(() => {
      const textWrapper = cartButton.querySelector('.text');
      if (textWrapper && !textWrapper.querySelector('.gs03-cart-price__compare')) {
        initState();
      }
    });

    observer.observe(cartButton, { childList: true, subtree: true });

    // Listen for upsell toggle events (bubbles from container)
    document.addEventListener('gs03:upsell-toggle', (e) => {
      if (!e?.detail) return;
      // Only process if it came from our container
      const targetContainer = e.target.closest('#gs03-v2');
      if (targetContainer === container) {
        applyState(Boolean(e.detail.selected), getCurrentBiMonthly());
      }
    });

    // Listen for frequency picker clicks — update current price for bi-monthly
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.gs03-frequency-option');
      if (!btn || !form || !form.contains(btn)) return;
      const isDeluxe = upsellCard.classList.contains('is-active');
      applyState(isDeluxe, isBiMonthlyBtn(btn));
    });

    // Retry initialization with requestAnimationFrame for dynamic content
    let retries = 0;
    function retryInit() {
      initState();
      if (retries++ < 20) {
        requestAnimationFrame(retryInit);
      }
    }

    retryInit();
  }

  // Safe initialization for IG
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGS03);
  } else {
    initGS03();
  }
})();

// GS07B — Frequency tag toggle (homepage + PDP).
// Swaps tag text + arrow position when the user clicks a .gs03-frequency-option.
(function () {
  function isBiMonthly(btn) {
    if (!btn) return false;
    var name = (btn.getAttribute('data-plan-name') || '').toLowerCase();
    return /\b2\s*months?\b/.test(name);
  }

  function findTagForPicker(picker) {
    if (!picker || !picker.parentElement) return null;
    return picker.parentElement.querySelector('.gs07b-tag');
  }

  function applyTagState(tag, biMonthly) {
    tag.classList.toggle('is-bimonthly', biMonthly);
    var monthlyLabel = tag.querySelector('[data-gs07b-tag-monthly]');
    var bimonthlyLabel = tag.querySelector('[data-gs07b-tag-bimonthly]');
    if (monthlyLabel) monthlyLabel.hidden = biMonthly;
    if (bimonthlyLabel) bimonthlyLabel.hidden = !biMonthly;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gs03-frequency-option');
    if (!btn) return;
    var picker = btn.closest('#gs03-frequency-picker, .gs03-frequency-picker');
    var tag = findTagForPicker(picker);
    if (!tag) return;
    applyTagState(tag, isBiMonthly(btn));
  });

  function initTagsFromInitialState() {
    var pickers = document.querySelectorAll('#gs03-frequency-picker, .gs03-frequency-picker');
    pickers.forEach(function (picker) {
      var tag = findTagForPicker(picker);
      if (!tag) return;
      var selected = picker.querySelector('.gs03-frequency-option.is-selected');
      applyTagState(tag, isBiMonthly(selected));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTagsFromInitialState);
  } else {
    initTagsFromInitialState();
  }
})();

// GS07B — PDP cart button compare/current price.
// Mirrors the homepage GS03 cart-button behavior on the PDP, where #gs03-v2
// doesn't exist. Updates current price when the user switches frequency.
(function () {
  function isBiMonthlyBtn(btn) {
    if (!btn) return false;
    var name = (btn.getAttribute('data-plan-name') || '').toLowerCase();
    return /\b2\s*months?\b/.test(name);
  }

  function initPDPCartButton() {
    // Skip if we're on a page that has the homepage GS03 container; that's handled by initGS03.
    if (document.getElementById('gs03-v2')) return;

    var button = document.querySelector('[data-gs03-cart-button]');
    var picker = document.getElementById('gs03-frequency-picker');
    if (!button || !picker) return;

    var defaults = { compare: '$213+', monthly: '$99', bimonthly: '$109' };
    var themePrices = window.themeSettings && window.themeSettings.subscriptionPrices && window.themeSettings.subscriptionPrices.regular;
    if (themePrices) {
      if (themePrices.compare) defaults.compare = themePrices.compare;
      if (themePrices.current) defaults.monthly = themePrices.current;
      if (themePrices.bimonthly) defaults.bimonthly = themePrices.bimonthly;
    }

    function buildMarkup(currentPrice) {
      return '<span class="gs03-cart-label">Add to cart</span>' +
        '<span class="gs03-cart-divider"> - </span>' +
        '<span class="gs03-cart-price">' +
        '<span class="gs03-cart-price__compare">' + defaults.compare + '</span>' +
        '<span class="gs03-cart-price__current">' + currentPrice + '</span>' +
        '</span>';
    }

    function ensureMarkup() {
      var span = button.querySelector('span');
      if (!span) return null;
      span.classList.add('text');
      if (!span.querySelector('.gs03-cart-price__current')) {
        var selected = picker.querySelector('.gs03-frequency-option.is-selected');
        var currentPrice = isBiMonthlyBtn(selected) ? defaults.bimonthly : defaults.monthly;
        span.innerHTML = buildMarkup(currentPrice);
      }
      return span.querySelector('.gs03-cart-price__current');
    }

    function applyState(biMonthly) {
      var price = biMonthly ? defaults.bimonthly : defaults.monthly;
      var currentNode = ensureMarkup();
      if (currentNode) currentNode.textContent = price;

      // Also update the standard product price element (.price-item--regular)
      // because Loop doesn't always re-render it when our picker changes the
      // hidden selector. Matches V1 behaviour. Note the non-capturing group
      // (?:\.\d{2})? — a capturing group would let "$1" in the replacement
      // be treated as a back-reference to the matched ".00", producing
      // garbage like ".0009.00".
      document.querySelectorAll('.price-item--regular').forEach(function (el) {
        el.textContent = el.textContent.replace(/\$\d{2,3}(?:\.\d{2})?/, price + '.00');
      });
    }

    // Frequency click listener
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.gs03-frequency-option');
      if (!btn || !picker.contains(btn)) return;
      applyState(isBiMonthlyBtn(btn));
    });

    // Observe button for Loop rewrites
    var paused = false;
    var observer = new MutationObserver(function () {
      if (paused) return;
      var span = button.querySelector('span.text');
      if (span && span.querySelector('.gs03-cart-price__current')) return;
      paused = true;
      ensureMarkup();
      setTimeout(function () { paused = false; }, 50);
    });
    observer.observe(button, { childList: true, subtree: true });

    // Initial sync
    var initialSelected = picker.querySelector('.gs03-frequency-option.is-selected');
    applyState(isBiMonthlyBtn(initialSelected));
  }

  // Retry until picker + button are mounted (Loop takes a moment)
  var attempts = 0;
  function tryInit() {
    if (document.querySelector('[data-gs03-cart-button]') && document.getElementById('gs03-frequency-picker')) {
      initPDPCartButton();
      return;
    }
    if (++attempts < 20) {
      setTimeout(tryInit, 150);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();